import axios from 'axios'
import { userParams } from './user'

/** 开发：.env.development → VUE_APP_API_BASE=http://bg.yasenkj.cn；生产同域留空 */
const API_BASE = process.env.VUE_APP_API_BASE || ''

function parseApiData(data) {
  if (data == null) return data
  if (typeof data === 'string') {
    const s = data.trim()
    if (s.startsWith('{') || s.startsWith('[')) {
      try { return JSON.parse(s) } catch (e) { /* keep string */ }
    }
    const jsonStart = s.indexOf('{')
    if (jsonStart >= 0) {
      try { return JSON.parse(s.slice(jsonStart)) } catch (e) { /* keep string */ }
    }
  }
  return data
}

const http = axios.create()
http.interceptors.response.use(res => {
  res.data = parseApiData(res.data)
  return res
})

const api = {
  get(action, params = {}) {
    params[action] = '1'
    return http.get(API_BASE + '/yn_api.php', { params: userParams(params) })
  },
  post(action, data = {}) {
    const form = new FormData()
    form.append('myaction', action)
    const params = userParams(data)
    Object.keys(params).forEach(k => {
      const v = params[k]
      if (v !== undefined && v !== null) form.append(k, v)
    })
    return http.post(API_BASE + '/yn_api.php', form)
  },
  postJson(action, data = {}) {
    const form = new FormData()
    form.append('myaction', action)
    const params = userParams({ body: JSON.stringify(data) })
    Object.keys(params).forEach(k => {
      const v = params[k]
      if (v !== undefined && v !== null) form.append(k, v)
    })
    return http.post(API_BASE + '/yn_api.php', form)
  },
  upload(action, file, extra = {}) {
    const form = new FormData()
    form.append('myaction', action)
    form.append('file', file)
    const merged = userParams(extra)
    if (!merged.yhid) {
      return Promise.reject(new Error('未登录，请重新登录后再上传'))
    }
    Object.keys(merged).forEach(k => form.append(k, merged[k]))
    return http.post(API_BASE + '/yn_api.php', form)
  }
}

export default api
